import { queryToString } from '../utils';
var WhatsappSocialNetwork = /** @class */ (function () {
    function WhatsappSocialNetwork() {
        this.type = 'whatsapp';
        this.baseUrl = 'https://api.whatsapp.com/send';
    }
    WhatsappSocialNetwork.prototype.getBasUrl = function () {
        return this.baseUrl;
    };
    WhatsappSocialNetwork.prototype.getQueryStringObj = function (dataObj) {
        return {
            text: dataObj.url,
        };
    };
    return WhatsappSocialNetwork;
}());
export { WhatsappSocialNetwork };
var FacebookSocialNetwork = /** @class */ (function () {
    function FacebookSocialNetwork() {
        this.type = 'facebook';
        this.baseUrl = 'http://www.facebook.com/sharer.php';
    }
    FacebookSocialNetwork.prototype.getBasUrl = function () {
        return this.baseUrl;
    };
    FacebookSocialNetwork.prototype.getQueryStringObj = function (dataObj) {
        var _a;
        return {
            u: dataObj.url,
            title: (_a = dataObj.title) !== null && _a !== void 0 ? _a : '',
        };
    };
    return FacebookSocialNetwork;
}());
export { FacebookSocialNetwork };
var TwitterSocialNetwork = /** @class */ (function () {
    function TwitterSocialNetwork() {
        this.type = 'twitter';
        this.baseUrl = 'https://twitter.com/intent/tweet';
    }
    TwitterSocialNetwork.prototype.getBasUrl = function () {
        return this.baseUrl;
    };
    TwitterSocialNetwork.prototype.getQueryStringObj = function (dataObj) {
        return {
            url: dataObj.url,
            text: "".concat(dataObj.title, "\n"),
        };
    };
    return TwitterSocialNetwork;
}());
export { TwitterSocialNetwork };
var PinterestSocialNetwork = /** @class */ (function () {
    function PinterestSocialNetwork() {
        this.type = 'pinterest';
        this.baseUrl = 'http://pinterest.com/pin/create/button/';
    }
    PinterestSocialNetwork.prototype.getBasUrl = function () {
        return this.baseUrl;
    };
    PinterestSocialNetwork.prototype.getQueryStringObj = function (dataObj) {
        var _a, _b;
        return {
            url: dataObj.url,
            media: (_a = dataObj.imageUrl) !== null && _a !== void 0 ? _a : '',
            description: (_b = dataObj.title) !== null && _b !== void 0 ? _b : '',
        };
    };
    return PinterestSocialNetwork;
}());
export { PinterestSocialNetwork };
var SocialShareService = /** @class */ (function () {
    function SocialShareService(vendor) {
        var _this = this;
        this.toQueryParams = function (dataObj) {
            var queryStringObj = _this.vendor.getQueryStringObj(dataObj);
            return queryToString(queryStringObj);
        };
        this.getSocialNetworkUrl = function (dataObj) {
            var baseUrl = _this.vendor.getBasUrl();
            var queryParams = _this.toQueryParams(dataObj);
            return "".concat(baseUrl, "?").concat(queryParams);
        };
        this.vendor = vendor;
    }
    return SocialShareService;
}());
export { SocialShareService };
//# sourceMappingURL=SocialShareService.js.map